<script setup>
import { VDataTable } from "vuetify/labs/VDataTable";
import { withQuery } from "ufo";
import moment from "moment-timezone";

moment.tz.setDefault("Asia/Jakarta");

definePage({
  meta: {
    layout: "default",
  },
});

const loading = ref();

const load = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
  }, 3000);
};

const route = useRoute();
const router = useRouter();

const errors = ref("");

const pageTitle = "Login User";

const { data: dataQuery } = await useApi(
  withQuery("/cms/users/" + route.params.id, {
    method: "GET",
  })
);
const data = dataQuery ? dataQuery.value?.data : [];

const dataStatus = ref(data.status);

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/login-user",
  },
  {
    title: data.loginId,
    to: null,
  },
];

const roleHeader = [
  {
    title: "Role Id",
    sortable: false,
    key: "id",
  },
  {
    title: "Role Name",
    key: "name",
  },
  {
    title: "Role Description",
    key: "description",
  },
];
const roleItems = [
  {
    id: 1,
    roleId: `001`,
    roleName: "Issuer",
    roleDescription: "Issuer 01",
  },
];

/*
 * Block / Unblock
 * */
const statusDialog = ref(false);
const statusType = ref(false);
const statusAlertBlock = ref(false);
const statusAlertUnblock = ref(false);
const statusItem = (i, e) => {
  statusAlertBlock.value = false;
  statusAlertUnblock.value = false;
  statusType.value = i;
  statusDialog.value = e;
};
const statusOk = async () => {
  try {
    load();
    const res = await $api(
      "/cms/users/" + statusType.value + "/" + statusDialog.value,
      {
        method: "POST",
        onResponseError({ response }) {
          errors.value = response._data.message;

          setTimeout(() => (errors.value = false), 10000);
        },
      }
    );

    if (res.statusCode === 200 || res.statusCode === 201) {
      statusDialog.value = false;
      if (statusType.value == "block") {
        statusAlertBlock.value = res.message;
        dataStatus.value = 2;
      } else {
        statusAlertUnblock.value = res.message;
        dataStatus.value = 1;
      }
      setTimeout(() => router.push({ path: "/admin/login-user" }), 2000);
    }
  } catch (err) {
    errors.value = err._data.message;

    setTimeout(() => (errors.value = false), 10000);
  }
};
const statusCancel = () => {
  statusDialog.value = false;
  statusAlertBlock.value = false;
  statusAlertUnblock.value = false;
};
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">{{ pageTitle }} Detail</h4>
  <VAlert v-show="statusAlertBlock" class="mb-5" closeable type="error">
    {{ statusAlertBlock }}
  </VAlert>
  <VAlert v-show="statusAlertUnblock" class="mb-5" closeable type="success">
    {{ statusAlertUnblock }}
  </VAlert>
  <VCard border class="v-card-data" title="Login User Information">
    <template #append>
      <div class="d-flex gap-4">
        <VBtn
          v-show="dataStatus == 2"
          :disabled="loading"
          :loading="loading"
          color="success"
          variant="tonal"
          @click="statusItem('unblock', data.id)"
        >
          <VIcon icon="tabler-lock-access-off" start />
          Unblock
          <template #loader>
            <span class="custom-loader">
              <VIcon class="text-white" icon="tabler-refresh" />
            </span>
          </template>
        </VBtn>
        <VBtn
          v-show="dataStatus == 1"
          :disabled="loading"
          :loading="loading"
          color="error"
          variant="tonal"
          @click="statusItem('block', data.id)"
        >
          <VIcon icon="tabler-lock-access" start />
          Block
          <template #loader>
            <span class="custom-loader">
              <VIcon class="text-white" icon="tabler-refresh" />
            </span>
          </template>
        </VBtn>
        <VBtn
          :to="{ path: '/admin/login-user/update/' + route.params.id }"
          color="primary"
        >
          <VIcon icon="tabler-pencil" start />
          Edit {{ pageTitle }}
        </VBtn>
      </div>
    </template>
    <VTable class="text-no-wrap" density="compact">
      <tbody>
        <tr v-show="dataStatus == 2" class="text-error">
          <td>Status</td>
          <td>Block</td>
        </tr>
        <tr>
          <td>Login ID</td>
          <td>{{ data.loginId }}</td>
        </tr>
        <tr>
          <td>User name</td>
          <td>{{ data.username }}</td>
        </tr>
        <tr>
          <td>Email Address</td>
          <td>{{ data.email }}</td>
        </tr>
        <tr>
          <td>Login Status</td>
          <td>{{ data.loginStatus }}</td>
        </tr>
        <tr>
          <td>Last login time</td>
          <td>
            {{
              data.lastLoginTime
                ? moment(data.lastLoginTime).format("LLL")
                : null
            }}
          </td>
        </tr>
      </tbody>
    </VTable>
    <VCardText>
      <VCard border>
        <VDataTable
          :headers="roleHeader"
          :items="data.roles"
          :paging="false"
          border
          class="py-5"
        />
      </VCard>
    </VCardText>
  </VCard>
  <div class="mx-auto text-center">
    <VBtn
      :to="{ path: '/admin/login-user' }"
      class="mt-5 mx-auto text-center"
      color="secondary"
    >
      <VIcon icon="tabler-refresh" start />
      Back to {{ pageTitle }} List
    </VBtn>
  </div>
  <!-- 👉 Block Dialog  -->
  <VDialog v-model="statusDialog" max-width="500px">
    <VCard>
      <VCardTitle class="text-center my-3">
        Are you sure you want to {{ statusType }} this {{ pageTitle }}?
      </VCardTitle>

      <VCardActions>
        <VSpacer />

        <VBtn color="secondary" variant="outlined" @click="statusCancel">
          Cancel
        </VBtn>

        <VBtn color="primary" variant="elevated" @click="statusOk"> OK</VBtn>

        <VSpacer />
      </VCardActions>
    </VCard>
  </VDialog>
</template>
